export default {
  // Tiêu đề trang
  'adsReport.title': 'Phân tích báo cáo',

  // Trường tìm kiếm
  'adsReport.dateRange': 'Phạm vi ngày',

  // Nút
  'adsReport.search': 'Tìm kiếm',
  'adsReport.reset': 'Đặt lại',
  'adsReport.export': 'Xuất',

  // Cột bảng
  'adsReport.serial': 'Số thứ tự',
  'adsReport.date': 'Ngày',
  'adsReport.agentName': 'Tên đại lý',
  'adsReport.adsPlatform': 'Nền tảng quy kết',
  'adsReport.adsName': 'Tên quy kết',
  'adsReport.eventName': 'Sự kiện quy kết',
  'adsReport.uploadCount': 'Số lượng tải lên',
  'adsReport.successCount': 'Số lượng thành công',

  // Thông báo
  'adsReport.fetchDataFailed': 'Không thể tải dữ liệu',
  'adsReport.noData': 'Không có dữ liệu',
  'adsReport.exportSuccess': 'Đã gửi tác vụ xuất, vui lòng xem trong danh sách tải xuống',
  'adsReport.exportFailed': 'Xuất thất bại',

  // Phân trang
  'adsReport.totalRecords': 'Tổng cộng {total} bản ghi',
  'adsReport.pagination': 'Trang {current} của {page}, Tổng cộng {total} bản ghi',
};
